const meta = {
  querying: 'Query data',
  analyze: 'Analyze data',
  alerts: 'Configure alerts',
  'logs-oem': {
    display: 'hidden',
  },
};

export default meta;
